import Typography from '@mui/material/Typography';
import { FormattedMessage, useIntl } from 'react-intl';
import { FilledSuccessBar } from '../../components/_DesignSystemWrappers/SuccessBar/FilledSuccessBar';
import messages from './messages';

export function SuccessMessage({ email }: { email: string }) {
  const { formatMessage } = useIntl();

  return (
    <FilledSuccessBar title={formatMessage(messages.RegisterImsSuccessTitle, { email })}>
      <Typography>
        <FormattedMessage
          {...messages.RegisterImsSuccessText}
          values={{
            br: <br />,
          }}
        />
      </Typography>
    </FilledSuccessBar>
  );
}
